export type AnyCanvas = HTMLCanvasElement | OffscreenCanvas;
export type Context2D = CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;

export function createCanvas(width: number, height: number): OffscreenCanvas {
  return new OffscreenCanvas(Math.max(1, Math.round(width)), Math.max(1, Math.round(height)));
}

export function get2d(canvas: AnyCanvas, options?: CanvasRenderingContext2DSettings): Context2D {
  const ctx = canvas.getContext('2d', options) as Context2D | null;
  if (!ctx) throw new Error('2D canvas is not available');
  return ctx;
}

/** Resizes a canvas only when needed (resizing clears it and is not free). */
export function ensureSize(canvas: AnyCanvas, width: number, height: number): void {
  const w = Math.max(1, Math.round(width));
  const h = Math.max(1, Math.round(height));
  if (canvas.width !== w) canvas.width = w;
  if (canvas.height !== h) canvas.height = h;
}
